function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M.4 1.3v509.3h826V1.3H.4"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#e61937",
  d: "M809.2 493.4H17.6v-475h791.6v475"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M155.4 322.6h.3a27.2 27.2 0 0 1 23.2-11.6c10.6 0 19.7 4.3 25 14a28 28 0 0 1 25-14c18.6 0 25 12.2 25 29v47h-26v-35.2c0-7.6.2-20-10.8-20-12 0-12.5 11.3-12.5 20V387h-26v-35c0-8.3 0-20.7-11.6-20.7s-11.6 12.4-11.6 20.6V387h-26v-73.5h26v9.2M307.8 333.6a16 16 0 0 1 16.7 16.6c0 9.3-6.1 16.5-16.7 16.5s-16.8-7.2-16.8-16.5a16 16 0 0 1 16.8-16.6zm42-20.2h-26.1v7.2a30 30 0 0 0-22.8-9.6c-21.8 0-36.8 18-36.8 39.1 0 21 15.3 39.3 37.1 39.3 8.6 0 17.6-3.4 22.2-10.7h.3v8.2h26v-73.5M392.8 325.5h.3c5-9 13.6-13 23.8-13h5v25c-3.6-2-7-2.4-11-2.4-14.5 0-18 9.6-18 22.2v29.6h-26.1v-73.5h26v12M453.7 340l27-26.6h35.7l-36.8 34 39 39.5h-36.4l-28.5-30v30h-26V268h26v72"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M540.7 339.5c1.5-7.6 7.8-11.6 15.4-11.6 7 0 13.5 4.6 14.8 11.6zm54.4 12.3c0-25-14.8-40.8-40.2-40.8-24 0-40.7 14.8-40.7 39.2 0 25.4 18.2 39.2 42.5 39.2 16.8 0 33.2-8 37.4-25.3h-25c-3 4.9-7 6.8-12.5 6.8-10.8 0-16.4-5.8-16.4-16.4h54.9v-2.7M644.8 333.6a16 16 0 0 1 16.8 16.6c0 9.3-6.2 16.5-16.8 16.5-10.6 0-16.7-7.2-16.7-16.5a16 16 0 0 1 16.7-16.6zm15.9 53.3h26V268h-26v52.6a30 30 0 0 0-22.8-9.6c-21.7 0-36.8 18-36.8 39.1 0 21 15.4 39.3 37.1 39.3 8.6 0 17.6-3.4 22.2-10.7h.3v8.2M620 113.3c-38.9 0-69.6 17.6-77.7 48.6-8-31-38.8-48.6-77.6-48.6-35.2 0-64 14.5-74.9 40.5-11-26-39.6-40.5-74.9-40.5-45.2 0-79.6 24-79.6 65.3 0 10.4 2.2 19.7 6.2 27.8l-1.5.7a69.7 69.7 0 0 1-27.2 5c-20.5 0-38.9-13-38.9-32.8 0-21.5 15.8-34.4 36.3-34.4 6.3 0 11.8.6 16.9 2 0 0 5.4-14.3 18.8-25.1l-4-1.7a92.4 92.4 0 0 0-37.2-6.8c-45.2 0-79.7 24-79.7 65.3 0 41 34.5 65 79.7 65 12 0 25.3-1.7 36.7-5 4.2-1 14.3-4.4 21.6-8.7a95.5 95.5 0 0 0 52 13.7c35.2 0 63.9-14.5 74.8-40.4 11 25.9 39.7 40.4 75 40.4 36 0 65-15.2 75.5-42v75.2h48.6v-37.4c9.5 2.8 20 4.2 31 4.2 45.3 0 79.7-24 79.7-65 0-41.4-34.4-65.3-79.7-65.3zM315 213.5c-21.9 0-30.8-16.5-30.8-34.9 0-18.7 9-35.2 30.7-35.2 21.9 0 30.8 16.5 30.8 35.2 0 18.4-9 34.9-30.8 34.9zm149.7 0c-21.8 0-30.7-16.5-30.7-34.9 0-18.7 8.9-35.2 30.7-35.2 21.8 0 30.8 16.5 30.8 35.2 0 18.4-9 34.9-30.8 34.9zm155.2 0c-21.8 0-30.7-16.5-30.7-34.9 0-18.7 8.9-35.2 30.7-35.2 21.8 0 30.8 16.5 30.8 35.2 0 18.4-9 34.9-30.8 34.9"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    shaperendering: "geometricPrecision",
    viewBox: "0 0 827 512"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/coop-marked.f33b372b.svg";
export { SvgComponent as ReactComponent };